import React from "react";
import Skeleton from "@mui/material/Skeleton";

const UserTimelineSkeleton = ({ title = "" }) => {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <div className="header-title">
          <h5 className="card-title subHeading position-relative mb-3">
            {title}
          </h5>
        </div>
      </div>
      <div className="card-body">
        <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
          <ul className="list-inline p-0 m-0 w-100">
            {[...Array(5)].map((data, index) => {
              return (
                <li key={`user_enggagement_skeleton_${index}`}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <Skeleton
                        className={`timeline-dots1 border-0`}
                        style={{
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                      />

                      <Skeleton className="mb-3 fw-semibold" width={300} />
                      <div className="d-flex gap-2 flex-wrap">
                        <Skeleton
                          className={`badge border rounded-pill d-flex align-items-center gap-1 px-3 py-2 fs-6 bg-opacity-10`}
                          width={200}
                          height={50}
                        />
                      </div>
                    </div>
                    <div>
                      <Skeleton className="m-0 p-0" width={200} />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserTimelineSkeleton;
